import { useContext, createContext } from 'react';
export const ConfigContext = /*#__PURE__*/createContext(null);
export function useConfig() {
  const context = useContext(ConfigContext);
  if (context === undefined) {
    throw new Error('useConfig must be used within a ConfigContext.Provider');
  }
  return context || {
    locale: 'en',
    regionalFormat: 'en'
  };
}
//# sourceMappingURL=config-context.js.map